"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HostPresentationControl = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactPdf = require("react-pdf");
require("react-pdf/dist/esm/Page/AnnotationLayer.css");
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PresentationControlPageInput = require("../PresentationControlPageInput");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _HostPresentationControl = require("./HostPresentationControl.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _hooks = require("../../hooks");
var _PDF = require("../PDF");
var _pdf = require("../../utils/pdf");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = (0, _pdf.pdfWorkerFactory)();
var HostPresentationControl = exports.HostPresentationControl = function HostPresentationControl(_ref) {
  var url = _ref.url,
    id = _ref.id,
    title = _ref.title,
    presentationValue = _ref.presentationValue,
    onSourceChanged = _ref.onSourceChanged,
    _ref$showNextLabel = _ref.showNextLabel,
    showNextLabel = _ref$showNextLabel === void 0 ? true : _ref$showNextLabel,
    _ref$showPreviousThum = _ref.showPreviousThumbnail,
    showPreviousThumbnail = _ref$showPreviousThum === void 0 ? true : _ref$showPreviousThum,
    _ref$showNextThumbnai = _ref.showNextThumbnail,
    showNextThumbnail = _ref$showNextThumbnai === void 0 ? true : _ref$showNextThumbnai;
  var maxWidth = 116;
  var maxHeight = 66;
  var iconSize = 'small';
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    leftRenderedPage = _useState2[0],
    setLeftRenderedPage = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    rightRenderedPage = _useState4[0],
    setRightRenderedPage = _useState4[1];
  var _usePresentationContr = (0, _hooks.usePresentationControl)({
      id: id,
      title: title,
      presentationValue: presentationValue,
      onSourceChanged: onSourceChanged
    }),
    numPages = _usePresentationContr.numPages,
    showPrevPageNumber = _usePresentationContr.showPrevPageNumber,
    setShowPrevPageNumber = _usePresentationContr.setShowPrevPageNumber,
    showNextPageNumber = _usePresentationContr.showNextPageNumber,
    setShowNextPageNumber = _usePresentationContr.setShowNextPageNumber,
    activePage = _usePresentationContr.activePage,
    onDocumentLoadSuccess = _usePresentationContr.onDocumentLoadSuccess,
    goToNextPage = _usePresentationContr.goToNextPage,
    goToPreviousPage = _usePresentationContr.goToPreviousPage,
    leftThumbnailPage = _usePresentationContr.leftThumbnailPage,
    rightThumbnailPage = _usePresentationContr.rightThumbnailPage,
    isDocumentLoaded = _usePresentationContr.isDocumentLoaded,
    inputPageNumber = _usePresentationContr.inputPageNumber,
    pageNumberInputHasError = _usePresentationContr.pageNumberInputHasError,
    handlePageInputKeyPress = _usePresentationContr.handlePageInputKeyPress,
    showInputForm = _usePresentationContr.showInputForm,
    presentationFooterRef = _usePresentationContr.presentationFooterRef,
    handlePageInputChange = _usePresentationContr.handlePageInputChange;
  var handlePreviousRenderSuccess = function handlePreviousRenderSuccess() {
    setLeftRenderedPage(leftThumbnailPage);
  };
  var handleNextRenderSuccess = function handleNextRenderSuccess() {
    setRightRenderedPage(rightThumbnailPage);
  };
  (0, _react.useEffect)(function () {
    if (activePage === numPages) {
      setRightRenderedPage(rightThumbnailPage);
    }
  }, [activePage]);
  if (!url) return null;
  var isRightThumbnailLoading = rightThumbnailPage !== rightRenderedPage && numPages > activePage;
  var isLeftThumbnailLoading = leftThumbnailPage !== leftRenderedPage && leftThumbnailPage > 0;
  var isAnyThumbnailLoading = isRightThumbnailLoading || isLeftThumbnailLoading;

  // A difference less than 0 means the next page is being rendered
  // A difference greater than 0 means the previous page is being rendered
  var difference = rightRenderedPage - rightThumbnailPage;
  var disablePreviousButton = activePage < numPages && difference !== 0 || activePage === 1;
  var disableNextButton = activePage >= numPages || difference !== 0;
  return /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.HostPresentationControlWrapper, {
    "data-testid": "host-presentation-control"
  }, /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.DocumentWrapper, {
    width: maxWidth,
    height: maxHeight,
    show: showPreviousThumbnail.toString(),
    "data-testid": "host-control-panel-prev-thumbnail",
    onMouseEnter: function onMouseEnter() {
      return setShowPrevPageNumber(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowPrevPageNumber(false);
    }
  }, leftThumbnailPage > 0 && /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.HoverPageNumber, {
    showPageNumber: showPrevPageNumber.toString()
  }, leftThumbnailPage), /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFDocument, {
    key: url,
    file: url,
    onLoadSuccess: onDocumentLoadSuccess,
    loading: /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.LoadingPage, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, null)),
    errorIconSize: iconSize
  }, leftThumbnailPage <= numPages && /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.StyledThumbnail, {
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    pageNumber: leftThumbnailPage,
    onRenderSuccess: handlePreviousRenderSuccess,
    renderAnnotationLayer: false,
    renderTextLayer: false,
    noData: /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.EmptyPresentationScreen, null)
  }))), /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.StyledPresentationControllers, null, /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.StyledButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.StyledPreviousButton, {
    size: "small",
    color: "light",
    variant: "outlined",
    disabled: disablePreviousButton,
    onClick: goToPreviousPage,
    "data-testid": "host-control-panel-prev-btn"
  }, /*#__PURE__*/_react["default"].createElement(PreviousLabel, {
    isLoading: difference > 0 && isAnyThumbnailLoading
  })), /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.StyledNextButton, {
    color: "primary",
    size: "small",
    disabled: disableNextButton,
    onClick: goToNextPage,
    "data-testid": "host-control-panel-next-btn"
  }, /*#__PURE__*/_react["default"].createElement(NextLabel, {
    isLoading: difference < 0 && activePage < numPages && isAnyThumbnailLoading,
    showNextLabel: showNextLabel
  }))), activePage <= numPages && /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.CurrentTotalPage, {
    ref: presentationFooterRef,
    show: isDocumentLoaded
  }, /*#__PURE__*/_react["default"].createElement(_PresentationControlPageInput.PresentationControlPageInput, {
    hasError: pageNumberInputHasError,
    inputValue: inputPageNumber,
    onChange: handlePageInputChange,
    onKeyPress: handlePageInputKeyPress,
    numPages: numPages,
    showInputForm: showInputForm
  }))), /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.DocumentWrapper, {
    width: maxWidth,
    height: maxHeight,
    show: showNextThumbnail.toString(),
    "data-testid": "host-control-panel-next-thumbnail",
    onMouseEnter: function onMouseEnter() {
      return setShowNextPageNumber(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowNextPageNumber(false);
    }
  }, rightThumbnailPage <= numPages && /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.HoverPageNumber, {
    showPageNumber: showNextPageNumber.toString()
  }, rightThumbnailPage), /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFDocument, {
    key: url,
    file: url,
    onLoadSuccess: onDocumentLoadSuccess,
    loading: /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.LoadingPage, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, null)),
    errorIconSize: iconSize
  }, rightThumbnailPage <= numPages && /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.StyledThumbnail, {
    pageNumber: rightThumbnailPage,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    onRenderSuccess: handleNextRenderSuccess,
    renderAnnotationLayer: false,
    renderTextLayer: false,
    error: /*#__PURE__*/_react["default"].createElement(_HostPresentationControl.EmptyPresentationScreen, null)
  }))));
};
var NextLabel = function NextLabel(_ref2) {
  var isLoading = _ref2.isLoading,
    showNextLabel = _ref2.showNextLabel;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
      "data-testid": "spinner-next",
      size: "sm"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "".concat(showNextLabel ? 'Next ' : ''), /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faArrowRight
  }));
};
var PreviousLabel = function PreviousLabel(_ref3) {
  var isLoading = _ref3.isLoading;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
      "data-testid": "spinner-previous",
      size: "sm"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faArrowLeft
  });
};
HostPresentationControl.propTypes = {
  url: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  presentationValue: _propTypes["default"].object.isRequired,
  onSourceChanged: _propTypes["default"].func.isRequired,
  showNextLabel: _propTypes["default"].bool,
  showPreviousThumbnail: _propTypes["default"].bool,
  showNextThumbnail: _propTypes["default"].bool
};